import { logErrorIfNotWebApiRequestCancellation } from "@faire/retailer-visitor-shared/lib/logErrorIfNotWebApiRequestCancellation";
import { useSearchPageFiltersQueryError } from "@faire/retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/DataFetching/Filters/useSearchPageFiltersQueryError";
import { useSearchPageQueryError } from "@faire/retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/DataFetching/Products/useSearchPageQueryError";
import { useEffect } from "react";

export const SearchPageLogErrorEffect = () => {
  const productError = useSearchPageQueryError();
  const filtersError = useSearchPageFiltersQueryError();
  const error = productError ?? filtersError;

  useEffect(() => {
    logErrorIfNotWebApiRequestCancellation(error);
  }, [error]);

  return null;
};
